import React from 'react'

import DistanceIcon from '../icons/hiker.svg'
import TimeIcon from '../icons/clock.svg'
import StageIcon from '../icons/calendar.svg'

import { DifficultText, DifficultIcon } from './Difficult'
import Distance from './Distance'
import TravelTime from './TravelTime'

import {
  ARRIVE_IN,
  DIFFICULT,
  DURATION,
  LENGTH,
  STAGES,
  START_FROM,
  TRAIL_LENGTH,
  TRAIL_STAGES_NUMBER,
  TRAIL_TRAVEL_TIME,
} from '../trans'

const TrailMeta = React.memo((props) => {

  const meta = props.metadata
  const key = new Date().getTime()

  return (
    <table className="pwa__metadata">

      <tbody className="pwa__metadata__header__container">
        <tr className="pwa__metadata__header">
          <th className="pwa__metadata__header__label">
            {START_FROM}
          </th>
          <td key={key} className="pwa__metadata__header__value fade-in delay">
            {meta.start_place.title}
          </td>
        </tr>

        <tr className="pwa__metadata__header">
          <th className="pwa__metadata__header__label">
            {ARRIVE_IN}
          </th>
          <td key={key} className="pwa__metadata__header__value fade-in delay">
            {meta.stop_place.title}
          </td>
        </tr>
      </tbody>

      <tbody className="pwa__metadata__cell__container">
        <tr className="pwa__metadata__cell">
          <th className="pwa__metadata__label">
            <DistanceIcon title={TRAIL_LENGTH}/>
            {LENGTH}
          </th>
          <td key={key} className="pwa__metadata__value fade-in delay">
            <Distance value={meta.length}/>
          </td>
        </tr>
        <tr className="pwa__metadata__cell">
          { ((!meta.trails || meta.trails.length === 1) && meta.time) && (
            <>
              <th className="pwa__metadata__label">
                <TimeIcon title={TRAIL_TRAVEL_TIME} />
                {DURATION}
              </th>
              <td key={key} className="pwa__metadata__value fade-in delay">
                <TravelTime value={meta.time}/>
              </td>
            </>
          )}
          { (meta.trails && meta.trails.length > 1) && (
            <>
              <th className="pwa__metadata__label">
                <StageIcon title={TRAIL_STAGES_NUMBER}/>
                {DURATION}
              </th>
              <td key={key} className="pwa__metadata__value fade-in delay">
                {meta.trails.length}&nbsp;{STAGES}
              </td>
            </>
          )}
        </tr>
        <tr className="pwa__metadata__cell">
          <th className="pwa__metadata__label">
            <DifficultIcon value={meta.difficult}/>
            {DIFFICULT}
          </th>
          <td key={key} className="pwa__metadata__value fade-in delay">
            <DifficultText value={meta.difficult}/>
          </td>
        </tr>
      </tbody>
    </table>
  )
})

export default TrailMeta
